var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-3"},[_c('h2',[_vm._v("设置")]),_c('SystemInfoCard'),_c('CacheStorageCard'),_c('JsDosSaveCard'),_c('EmularitySaveCard'),_c('ObjectStorageHostCard'),_c('BinaryHostCard'),_c('CloudflareHostCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }